export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "dashboard"
  },
  {
    url: "/administrator",
    name: "จัดการแอคมิน",
    slug: "admin"
  },
  {
    url: "/user",
    name: "จัดการผู้เรียน",
    slug: "user"
  },
  {
    url: "/lecturer",
    name: "จัดการผู้สอน",
    slug: "lecturer"
  },
  {
    url: "/banner",
    name: "จัดการ Banner",
    slug: "banner"
  },
  {
    url: "/organization",
    name: "ประเภทผู้เรียน",
    slug: "organization"
  },
  {
    url: "/curriculum",
    name: "จัดการหลักสูตร",
    slug: "curriculum",
    submenu: [
      {
        url: "/curriculumtype",
        name: "ประเภทหลักสูตร",
        slug: "curriculumtype"
      },
      {
        url: "/curriculum",
        name: "หลักสูตร",
        slug: "curriculum"
      }
    ]
  },
  {
    url: "/payment",
    name: "การจ่ายเงิน",
    slug: "payment"
  },
  {
    url: "/promotion",
    name: "จัดการโปรโมชั่น",
    slug: "promotion"
  },
  {
    url: "/setting",
    name: "ตั้งค่า",
    slug: "setting"
  }
];
